import React from "react";
const ParticipantRank = (props) => {
    if (props.showJersey) {
        return (React.createElement("img", { src: "/public/images/svgs/leaderboard-jersey.svg", className: "rounded-0", alt: "" }));
    }
    return React.createElement("p", { className: "m-0" }, props.rank);
};
export default ParticipantRank;
